<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        用户新增
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <el-button
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        >
          保存
        </el-button>
        <el-button
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        >
          关闭
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-alert
          v-show="editCapacityVo"
          class="u-mg-b-8"
          type="warning"
          title="用户存在提示"
          show-icon
          :closable="false"
        >
          编码为<span class="u-text-success u-text-14">【{{ fd.userVO.userCode }}】</span>的用户已经存在其他组织信息，部门再新增用户，转为在<span class="u-text-success u-text-14">【{{ fd.capacityVO.deptName }}】</span>组织下新增身份信息。
          <el-button
            class="u-mg-l-6"
            @click="handleClickReset"
          >
            重新输入用户
          </el-button>
        </el-alert>
        <el-form
          ref="fd"
          class="c-form"
          :model="fd"
          :rules="fdRules"
          :inline="true"
          :validate-on-rule-change="false"
          label-position="right"
          label-width="118px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              用户基本信息
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="用户编码"
                prop="userVO.userCode"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.userCode"
                  class="c-form__input"
                  placeholder=""
                  @change="handleUserCodeChange"
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.userCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="用户名称"
                prop="userVO.userName"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.userName"
                  class="c-form__input"
                  placeholder=""
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.userName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
                prop="userVO.tel"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.tel"
                  class="c-form__input"
                  placeholder=""
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.tel }}
                </span>
              </el-form-item>
            </el-col>
            <!-- <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="是否锁定"
                prop="userVO.locked"
              >
                <el-radio-group
                  v-if="!editCapacityVo"
                  v-model="fd.userVO.locked"
                  class="c-form__radio-group"
                >
                  <el-radio label="N">
                    非锁定
                  </el-radio>
                  <el-radio label="Y">
                    锁定
                  </el-radio>
                </el-radio-group>
                <span
                  v-else
                  class="c-form__read"
                >
                {{ fd.userVO.locked === 'Y' ? '非锁定' : '锁定' }}
                </span>
              </el-form-item>
            </el-col> -->
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效标志"
                prop="userVO.valid"
              >
                <el-radio-group
                  v-if="!editCapacityVo"
                  v-model="fd.userVO.valid"
                  class="c-form__radio-group"
                >
                  <el-radio label="Y">
                    有效
                  </el-radio>
                  <el-radio label="N">
                    无效
                  </el-radio>
                </el-radio-group>
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.valid === 'Y' ? '有效' : '无效' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="邮箱"
                prop="userVO.email"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.email"
                  class="c-form__input"
                  placeholder=""
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.email }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="数据来源"
                prop="userVO.sourceType"
              >
                自建
              </el-form-item>
            </el-col>
            <el-col
              v-for="(attrUserItem, index) in attrUserList"
              :key="'attrUser'+ index"
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                :label="attrUserItem.attrName"
                :prop="'userVO.attrs.' + attrUserItem.attrKey"
              >
                <template v-if="attrUserItem.enums">
                  <template v-if="enums[attrUserItem.enums] && Object.keys(enums[attrUserItem.enums]).length <= 2">
                    <el-radio-group
                      v-if="!editCapacityVo"
                      v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                      class="c-form__radio-group"
                    >
                      <el-radio
                        v-for="value in enums[attrUserItem.enums]"
                        :key="value.id"
                        :label="value.id"
                      >
                        {{ value.text }}
                      </el-radio>
                    </el-radio-group>
                    <span
                      v-else
                      class="c-form__read"
                    >
                      {{ fd.userVO.attrs[attrUserItem.attrKey] | enums(attrUserItem.enums) }}
                    </span>
                  </template>
                  <template v-else>
                    <el-select
                      v-if="!editCapacityVo"
                      v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                      class="c-form__select"
                      style="width: 100%;"
                      placeholder=""
                      clearable
                    >
                      <el-option
                        v-for="(value) in enums[attrUserItem.enums]"
                        :key="value.id"
                        :label="value.text"
                        :value="value.id"
                      />
                    </el-select>
                    <span
                      v-else
                      class="c-form__read"
                    >
                      {{ fd.userVO.attrs[attrUserItem.attrKey] | enums(attrUserItem.enums) }}
                    </span>
                  </template>
                </template>
                <template v-else-if="attrUserItem.attrType === 'String' || attrUserItem.attrType === 'Double'">
                  <el-input
                    v-if="!editCapacityVo"
                    v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__input"
                    placeholder=""
                  />
                  <span
                    v-else
                    class="c-form__read"
                  >
                    {{ fd.userVO.attrs[attrUserItem.attrKey] }}
                  </span>
                </template>
                <template v-else-if="attrUserItem.attrType === 'Date'">
                  <el-date-picker
                    v-if="!editCapacityVo"
                    v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__date"
                    type="date"
                    placeholder="选择日期"
                    value-format="timestamp"
                  />
                  <span
                    v-else
                    class="c-form__read"
                  >
                    {{ fd.userVO.attrs[attrUserItem.attrKey] | date('yyyy-MM-dd') }}
                  </span>
                </template>
              </el-form-item>
            </el-col>
            <!-- col空白占位填充 -->
            <el-col
              v-if="attrUserList.length%2 > 0"
              class="c-form__col c-form__placeholder"
              :span="12"
            />

            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              用户登录账号信息
            </el-col>
            <el-col
              class="c-form__col"
              :span="editCapacityVo ? 24 : 12"
            >
              <el-form-item
                class="c-form__item"
                label="登录账号"
                prop="userAuthVO.account"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userAuthVO.account"
                  class="c-form__input"
                  placeholder=""
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userAuthVO.account }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              v-if="!editCapacityVo"
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="登录密码"
                prop="userAuthVO.pwd"
              >
                <el-input
                  v-model.trim="fd.userAuthVO.pwd"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效期起"
                prop="userAuthVO.effectStartDate"
              >
                <el-date-picker
                  v-if="!editCapacityVo"
                  v-model="fd.userAuthVO.effectStartDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userAuthVO.effectStartDate | date('yyyy-MM-dd') }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效期止"
                prop="userAuthVO.effectEndDate"
              >
                <el-date-picker
                  v-if="!editCapacityVo"
                  v-model="fd.userAuthVO.effectEndDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userAuthVO.effectStartDate | date('yyyy-MM-dd') }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              用户身份信息
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="身份代码"
                prop="capacityVO.capacityCode"
              >
                <el-input
                  v-model.trim="fd.capacityVO.capacityCode"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="身份名称"
                prop="capacityVO.capacityName"
              >
                <el-input
                  v-model.trim="fd.capacityVO.capacityName"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="身份有效期起"
                prop="capacityVO.effectStartDate"
              >
                <el-date-picker
                  v-model="fd.capacityVO.effectStartDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="身份有效期止"
                prop="capacityVO.effectEndDate"
              >
                <el-date-picker
                  v-model="fd.capacityVO.effectEndDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="所属组织"
                prop="capacityVO.deptCode"
              >
                <hm-tree-select
                  v-if="!editCapacityVo"
                  ref="dept"
                  v-model="fd.capacityVO.deptCode"
                  class="c-tree-select-wrap"
                  instance-id="cTreeSelect"
                  placeholder="请选择所属组织"
                  :append-to-body="true"
                  :options="deptList"
                  :normalizer="normalizer"
                  :clearable="false"
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.capacityVO.deptName }}
                </span>
              </el-form-item>
            </el-col>

            <el-col
              v-for="(attrCapacityItem, index) in attrCapacityList"
              :key="'attrCapacity'+ index"
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                :label="attrCapacityItem.attrName"
                :prop="'capacityVO.attrs.' + attrCapacityItem.attrKey"
              >
                <template v-if="attrCapacityItem.enums">
                  <template v-if="enums[attrCapacityItem.enums] && Object.keys(enums[attrCapacityItem.enums]).length <= 2">
                    <el-radio-group
                      v-model="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                      class="c-form__radio-group"
                    >
                      <el-radio
                        v-for="value in enums[attrCapacityItem.enums]"
                        :key="value.id"
                        :label="value.id"
                      >
                        {{ value.text }}
                      </el-radio>
                    </el-radio-group>
                  </template>
                  <template v-else>
                    <el-select
                      v-model="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                      class="c-form__select"
                      style="width: 100%;"
                      placeholder=""
                      clearable
                    >
                      <el-option
                        v-for="(value) in enums[attrCapacityItem.enums]"
                        :key="value.id"
                        :label="value.text"
                        :value="value.id"
                      />
                    </el-select>
                  </template>
                </template>
                <template v-else-if="attrCapacityItem.attrType === 'String' || attrUserItem.attrType === 'Double'">
                  <el-input
                    v-model.trim="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                    class="c-form__input"
                    placeholder=""
                  />
                </template>
                <template v-else-if="attrCapacityItem.attrType === 'Date'">
                  <el-date-picker
                    v-model.trim="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                    class="c-form__date"
                    type="date"
                    placeholder="选择日期"
                    value-format="timestamp"
                  />
                </template>
              </el-form-item>
            </el-col>
            <!-- col空白占位填充 -->
            <el-col
              v-if="attrCapacityList.length%2===0"
              class="c-form__col c-form__placeholder"
              :span="12"
            />
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>

<script>
import { userService, getPositionList, allDeptTree, capacityService } from './user.service';
import { attrUser, attrCapacity } from '../attr.service';

export default {
  name: 'AttrAddUser',
  data () {
    return {
      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        /* 表单参数必须写入，无默认值为null，避免页面加载时由于使用了对象里不存在的参数而出现报错信息 */
        // 用户信息
        userVO: {
          locked: 'N', // 是否锁定
          sourceType: '0', // 数据来源
          tel: null, // 联系电话
          userName: null, // 用户名称
          userCode: null, // 用户编码
          valid: 'Y', // 有效标志
          attrs: {} // 扩展字段
        },
        // 用户帐号信息
        userAuthVO: {
          account: null, // 帐号
          effectEndDate: null, // 有效期止
          effectStartDate: null, // 有效期起
          pwd: null // 密码
        },
        // 用户主身份信息 ,
        capacityVO: {
          capacityName: null, // 身份名称
          capacityCode: null, // 身份代码
          deptCode: null, // 身份所属组织/部门
          effectEndDate: null, // 身份有效期止
          effectStartDate: null, // 身份有效期起
          attrs: {} // 扩展字段
        }
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        'userVO.userCode': [
          this.$validUtils.required('用户编码'),
          this.$HMValidator.maxLength('用户编码', 36)
        ],
        'userVO.userName': [
          this.$validUtils.required('用户名称'),
          this.$HMValidator.maxLength('用户名称', 75)
        ],
        'userVO.tel': [
          this.$validUtils.required('联系电话'),
          this.$HMValidator.maxLength('联系电话', 11)
        ],
        'userVO.email': [
          this.$HMValidator.email('邮箱'),
          this.$HMValidator.maxLength('邮箱', 90)
        ],
        'userVO.locked': [this.$validUtils.required('是否锁定')],
        'userVO.valid': [this.$validUtils.required('有效标志')],
        'userVO.idNum': [
          this.$validUtils.required('身份证件号码'),
          this.$HMValidator.IDCard_18('身份证件号码')
        ],
        'userVO.sex': [this.$validUtils.required('性别')],
        'userVO.joinTime': [
          this.$validUtils.required('入职时间'),
          this.$HMValidator.startTime(this, 'fd', 'userVO.leaveTime', ['入职时间', '离职时间'])
        ],
        'userVO.leaveTime': [
          this.$HMValidator.endTime(this, 'fd', 'userVO.joinTime', ['入职时间', '离职时间'])
        ],
        'userAuthVO.account': [
          this.$validUtils.required('登录账号'),
          this.$HMValidator.maxLength('登录账号', 75)
        ],
        'userAuthVO.pwd': [this.$validUtils.required('登录密码')],
        'userAuthVO.effectStartDate': [
          this.$validUtils.required('有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'userAuthVO.effectEndDate', ['有效期起', '有效期止'])
        ],
        'userAuthVO.effectEndDate': [
          this.$validUtils.required('有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'userAuthVO.effectStartDate', ['有效期起', '有效期止'])
        ],
        'capacityVO.capacityCode': [
          this.$validUtils.required('身份代码'),
          this.$HMValidator.maxLength('身份代码', 36)
        ],
        'capacityVO.capacityName': [
          this.$validUtils.required('身份名称'),
          this.$HMValidator.maxLength('身份名称', 113)
        ],
        'capacityVO.effectStartDate': [
          this.$validUtils.required('身份有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'capacityVO.effectEndDate', ['身份有效期起', '身份有效期止'])
        ],
        'capacityVO.effectEndDate': [
          this.$validUtils.required('身份有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'capacityVO.effectStartDate', ['身份有效期起', '身份有效期止'])
        ],
        'capacityVO.deptCode': [
          this.$validUtils.required('所属组织')
        ]
      },
      /* 表单校验规则 End */

      positionList: [], // 职位列表

      deptName: null, // 所属组织名称，用于页面展示

      deptList: [],

      /* 扩展字段 Start */
      attrUserList: [], // 用户
      attrCapacityList: [], // 身份
      /* 扩展字段 End */

      editCapacityVo: false // 该用户已经存在部门信息，选择新增用户身份
    };
  },
  computed: {
    // 获取枚举
    enums () {
      const baseEnums = this.$HMStoreService.getEnums();
      const apiEnumsObj = this.$store.state.apiEnums;
      const apiKey = Object.keys(apiEnumsObj);
      let apiEnums = {};
      apiKey.forEach(_key => {
        apiEnums = Object.assign({}, apiEnums, apiEnumsObj[_key]);
      });
      return Object.assign({}, baseEnums, apiEnums);
    }
  },
  methods: {
    /**
     * @description: 转换下拉树节点字段
     * @param {*}
     * @return {*}
     */
    normalizer (node) {
      if (node.childNodes == null || node.childNodes.length === 0) {
        return {
          id: node.nodeCode,
          label: node.nodeName
        };
      }
      return {
        id: node.nodeCode,
        label: node.nodeName,
        children: node.childNodes
      };
    },
    /**
     * @description: 获取组织机构树
     * @param {*}
     * @return {*}
     */
    getAllDeptTree () {
      allDeptTree()
        .then(rsp => {
          this.deptList = rsp.data;
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    /**
     * @description: 获取扩展字段
     * @param {*}
     * @return {*}
     */
    getAttr () {
      // 获取用户扩展字段
      attrUser()
        .then(rsp => {
          this.attrUserList = rsp.data.filter(item => {
            return item.show === 'Y';
          });
          this.attrUserList.map(attrUserItem => {
            this.attrSetToData(attrUserItem, this.fd.userVO.attrs, this.fdRules, 'userVO.attrs.' + attrUserItem.attrKey);
          });
        });
      // 获取身份扩展字段
      attrCapacity()
        .then(rsp => {
          this.attrCapacityList = rsp.data.filter(item => {
            return item.show === 'Y';
          });
          this.attrCapacityList.map(attrUserItem => {
            this.attrSetToData(attrUserItem, this.fd.capacityVO.attrs, this.fdRules, 'capacityVO.attrs.' + attrUserItem.attrKey);
          });
        });
    },
    /**
     * @description: 设置扩展字段到form表单数据、规则中
     * @param {Object} _attr 扩展字段
     * @param {Object} _formVo 表单数据对象
     * @param {Object} _formRules 校验规则对象
     * @param {String} _formRuleAttr 校验规则的属性
     * @return {*}
     */
    attrSetToData (_attr, _formVo, _formRules, _formRuleAttr) {
      this.$set(_formVo, _attr.attrKey, null);
      // 设置扩展字段校验规则
      this.$set(_formRules, _formRuleAttr, []);
      //  若扩展字段有必填标志，添加必填校验
      if (_attr.attrRequired === 'Y') {
        this.$set(_formRules, _formRuleAttr, [
          this.$validUtils.required(_attr.attrName)
        ]);
      }
      // 若扩展字段有自定义的校验规则，添加自定义的校验规则
      if (_attr.patterns) {
        const patterns = (_field, pattern) => {
          return {
            pattern: patterns,
            message: `【${_field}】校验不通过`,
            trigger: ['blur', 'change']
          };
        };
        // 向已有扩展字段校验规则数组末添加自定义校验规则
        this.$set(_formRules[_formRuleAttr], _formRules[_formRuleAttr].length,
          patterns(_attr.attrName, _attr.patterns));
      }
    },
    /**
     * @description: 获取职位列表
     * @return {*}
     */
    getPositionList () {
      getPositionList()
        .then(rsp => {
          this.positionList = rsp.data.filter(item => {
            return item.status === '使用';
          });
        })
        .catch(err => {
          console.error('获取职位列表错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 用户编码变化调用方法
     * @param {String} val， 用户编码
     * @return {*}
     */
    handleUserCodeChange (val) {
      if (val) {
        // 设置用户用户登录账号默认为用户编码
        if (!this.fd.userAuthVO.account) {
          this.fd.userAuthVO.account = val;
        }
        // 设置用户身份默认为用户编码
        if (!this.fd.capacityVO.capacityCode) {
          this.fd.capacityVO.capacityCode = val;
        }
        this.isExistInCurrent();
      }
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          // 如果是新增用户，调用新增用户接口
          if (!_this.editCapacityVo) {
            userService.save(_this.fd)
              .then(rsp => {
                _this.$alert('新增成功！', '提示', {
                  confirmButtonText: '确定',
                  type: 'success',
                  callback: action => {
                  }
                });
                _this.closeNavTabAndTo({ name: 'attrUserManage', params: { isRefresh: true } }, true);
              })
              .catch(err => {
                console.error('用户新增出错！', err);
              })
              .finally(() => {
                _this.loading = false;
              });
          } else {
            // 用户已存在，在该部门新增用户身份，调用新增身份接口
            const submitFd = JSON.parse(JSON.stringify(_this.fd.capacityVO));
            submitFd.valid = 'Y';
            submitFd.userCode = _this.fd.userVO.userCode;
            capacityService.save(submitFd)
              .then(rsp => {
                _this.$alert('新增成功！', '提示', {
                  confirmButtonText: '确定',
                  type: 'success',
                  callback: action => {
                  }
                });
                _this.closeNavTabAndTo({ name: 'attrUserManage', params: { isRefresh: true } }, true);
              })
              .catch(err => {
                console.error('新增身份出错', err);
              })
              .finally(() => {
                _this.loading = false;
              });
          }
        }
      });
    },
    /**
     * @description: 判断当前部门下是否已经存在当前用户的基本信息和身份信息
     * @param {*}
     * @return {*} Boolean
     */
    isExistInCurrent () {
      this.loading = true;
      userService.getDeptUserInfo(this.fd.userVO.userCode, this.fd.capacityVO.deptCode)
        .then(rsp => {
          const isUserInfo = rsp.data.data;
          if (isUserInfo) {
            this.$alert('该用户信息已经存在，不能添加用户！', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              callback: action => {
                this.$refs.fd.resetFields();
              }
            });
            this.loading = false;
            return;
          }
          this.numInOtherDept();
        }).catch(err => {
          console.error('查询出错', err);
          this.loading = false;
          this.$refs.fd.resetFields();
        });
    },
    /**
     * @description: 判断其他部门是否存在该用户信息
     * @param {*}
     * @return {*} 其他部门存在该用户的数量
     */
    numInOtherDept () {
      userService.userInOtherDept(this.fd.capacityVO.deptCode, this.fd.userVO.userCode)
        .then(rsp => {
          const num = rsp.data.data;
          if (num > 0) {
            this.$confirm('该用户已经存在部门信息，但在本级机构下不存在身份信息，是否在本机构下新增身份信息？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              type: 'warning'
            }).then(() => {
              /* const params = {
                deptCode: this.fd.capacityVO.deptCode,
                deptName: this.$refs.dept.selectedNodes[0].label,
                userCode: this.fd.userVO.userCode,
                addFrom: 'addUser'
              }; */
              // 在当前部分添加用户身份（由新增用户跳转）
              // this.handleDialog('addCapacityToDept', params);
              // 用户新增身份，初始化用户信息
              this.initUserByCode(this.fd.userVO.userCode);
            }).catch(() => {
              this.$refs.fd.resetFields();
            });
          }
          this.loading = false;
        }).catch(err => {
          console.error('查询出错', err);
          this.loading = false;
        });
    },
    /**
     * @description: 初始化用户信息
     * @param {*}
     * @return {*}
     */
    initUserByCode () {
      this.loading = true;
      userService.getUserInfo(this.fd.userVO.userCode)
        .then(rsp => {
          this.editCapacityVo = true;
          this.fd.userVO = Object.assign({}, this.fd.userVO, rsp.data.userVO);
          this.fd.userAuthVO = Object.assign({}, this.fd.userAuthVO, rsp.data.userAuthVO);
          this.fd.capacityVO.capacityName = rsp.data.userVO.userName;
          this.fd.capacityVO.effectStartDate = new Date().getTime();
          const nextY = new Date(this.fd.capacityVO.effectStartDate);
          nextY.setFullYear(nextY.getFullYear() + 1);
          nextY.setDate(nextY.getDate() - 1);
          this.fd.capacityVO.effectEndDate = new Date(nextY).getTime();
          this.fd.capacityVO.deptName = this.$refs.dept.selectedNodes[0].label;
        })
        .catch(err => {
          console.error('初始化数据出错', err);
          this.editCapacityVo = false;
          this.$refs.fd.resetFields();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClickReset () {
      this.$refs.fd.resetFields();
      this.editCapacityVo = false;
    }
  },
  created () {
    this.loading = true;
    // this.getPositionList();

    // 获取扩展字段
    this.getAttr();
    // 获取组织机构
    this.getAllDeptTree();

    /* 初始化时间起止 Start */
    this.fd.userAuthVO.effectStartDate = new Date().getTime();
    this.fd.capacityVO.effectStartDate = new Date().getTime();
    const nextY = new Date(this.fd.capacityVO.effectStartDate);
    nextY.setFullYear(nextY.getFullYear() + 1);
    nextY.setDate(nextY.getDate() - 1);
    this.fd.userAuthVO.effectEndDate = new Date(nextY).getTime();
    this.fd.capacityVO.effectEndDate = new Date(nextY).getTime();
    /* 初始化时间起止 End */

    // 获取路由的机构代码
    this.fd.capacityVO.deptCode = this.$route.params.deptCode;
  }
};
</script>
